export const mockBillHistory = [
  {
    billType: "subscription",
    priceType: "plus",
    payTerm: "month",
    licenseCount: 10,
    userPerStorage: 5,
    totalPrice: 100000,
    currency: "WON",
    payDate: "20240301",
    subscriptionStartDate: "20240301",
    subscriptionEndDate: "20240331",
    serviceBillHisUid: "bill_001",
    payCompany: "INICIS",
    inicisTid: "INICIS_TID_001",
    confirmUrl: "CONFIRMED",
  },
  {
    billType: "subscription",
    priceType: "basic",
    payTerm: "year",
    licenseCount: 5,
    userPerStorage: 3,
    totalPrice: 500000,
    currency: "WON",
    payDate: "20240201",
    subscriptionStartDate: "20240201",
    subscriptionEndDate: "20250131",
    serviceBillHisUid: "bill_002",
    payCompany: "CASH",
    confirmUrl: "CONFIRMED",
  },
  {
    billType: "subscription",
    priceType: "cancel",
    payTerm: "month",
    licenseCount: 8,
    userPerStorage: 4,
    totalPrice: -50000,
    currency: "WON",
    payDate: "20240115",
    subscriptionStartDate: "20240101",
    subscriptionEndDate: "20240131",
    serviceBillHisUid: "bill_003",
    payCompany: "INICIS",
    inicisTid: "INICIS_TID_002",
    confirmUrl: "CANCEL",
  },
  {
    billType: "subscription",
    priceType: "trial",
    payTerm: "month",
    licenseCount: 3,
    userPerStorage: 2,
    totalPrice: 0,
    currency: "WON",
    payDate: "20231201",
    subscriptionStartDate: "20231201",
    subscriptionEndDate: "20231231",
    serviceBillHisUid: "bill_004",
    payCompany: "INICIS",
    confirmUrl: "CONFIRMED",
  },
];
